export const formatPrice = (number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  }).format(number);
};

export const mobileValidate = (number) => {
  const regexpMobile = /^[0-9\b]+$/;
  if (number === "" || regexpMobile.test(number)) {
    return true;
  }
  return false;
};
export const emailValidate = (emailid) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(emailid)) {
    return true;
  }
  return false;
};
export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return ["all", ...new Set(unique)];
};
export const getUniqueValuesHome = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return [...new Set(unique)];
};

export const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

/**
 * Parses supply length in months from a product_name.
 * Defaults to 1 when parsing fails.
 * e.g. "Semaglutide - 3 months supply" → 3
 */
export const getSupplyMonthsFromProductName = (productName) => {
  if (!productName || typeof productName !== "string") {
    return 1;
  }

  const match = productName.match(/(\d+)\s*months?/i);
  if (!match) {
    return 1;
  }

  const months = parseInt(match[1], 10);
  if (!months || Number.isNaN(months)) {
    return 1;
  }

  return months;
};

export const toFiniteNumber = (value, fallback = 0) => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  const parsed = typeof value === "number" ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const hasPercentDiscount = (discountPercent) => {
  if (
    discountPercent === null ||
    discountPercent === undefined ||
    discountPercent === "" ||
    discountPercent === "0.00" ||
    discountPercent === 0 ||
    discountPercent === "0"
  ) {
    return false;
  }
  const percent = parseFloat(discountPercent);
  return Number.isFinite(percent) && percent !== 0;
};

export const getDiscountedOrderTotal = (
  originalTotal,
  discountPercent,
  discountAmount
) => {
  const original = toFiniteNumber(originalTotal, 0);
  let discounted = original;

  if (hasPercentDiscount(discountPercent)) {
    discounted = original - (original * toFiniteNumber(discountPercent, 0)) / 100;
  } else {
    discounted = original - toFiniteNumber(discountAmount, 0);
  }

  if (!Number.isFinite(discounted)) {
    return original;
  }

  return Math.max(0, discounted);
};

export const getCouponSavingsDisplay = (originalTotal, discountedTotal) => {
  const original = toFiniteNumber(originalTotal, 0);
  const discounted = toFiniteNumber(discountedTotal, original);
  const rawSavedAmount = original - discounted;
  const savedAmount =
    Number.isFinite(rawSavedAmount) && rawSavedAmount > 0 ? rawSavedAmount : 0;

  let savedPercent = 0;
  if (original > 0 && savedAmount > 0) {
    savedPercent = (savedAmount / original) * 100;
  }
  if (!Number.isFinite(savedPercent) || savedPercent < 0) {
    savedPercent = 0;
  }

  const displayPercent = Math.trunc(savedPercent);
  const safeDisplayPercent = Number.isFinite(displayPercent)
    ? displayPercent
    : 0;

  const displayAmount = Number.isFinite(savedAmount)
    ? savedAmount.toFixed(2)
    : "0.00";

  return {
    savedAmount,
    savedPercent,
    displayPercent: safeDisplayPercent,
    displayAmount,
    hasValidSavings:
      savedAmount > 0 &&
      Number.isFinite(savedAmount) &&
      displayAmount !== "NaN" &&
      displayAmount !== "Infinity",
  };
};

/**
 * Returns disclaimer wording derived from product_name.
 * 1 month keeps monthly copy; 3/6/12 use multi-month supply wording.
 */
export const getDisclaimerSupplyCopy = (productName) => {
  const months = getSupplyMonthsFromProductName(productName);
  const isMonthly = months === 1;

  return {
    months,
    isMonthly,
    supplyLabel: isMonthly ? "1 month supply" : `${months} months supply`,
    packageLabel: isMonthly ? "monthly package" : `${months}-month package`,
    starterKitLabel: isMonthly
      ? "1 month starter kit"
      : `${months} month starter kit`,
    checkInLabel: isMonthly
      ? "Each month,"
      : "At the end of your current supply period,",
  };
};
